module.exports = __webpack_public_path__ + "static/media/flagpatches.3bcbcafb.jpg";